var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCashBanksMovements(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 640,
    viewBox: "0 0 480 480",
    width: 640,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352 192H0v160c0 17.672 14.328 32 32 32h288c17.672 0 32-14.328 32-32zm0 0",
    fill: "#2b8838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320 352V192H0v160c0 17.672 14.328 32 32 32h256c17.672 0 32-14.328 32-32zm0 0",
    fill: "#39b54a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M288 384H32c-17.672 0-32-14.328-32-32v-16h320v16c0 17.672-14.328 32-32 32zm0 0",
    fill: "#006837"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M352 192H0V32C0 14.328 14.328 0 32 0h288c17.672 0 32 14.328 32 32zm0 0",
    fill: "#2b8838"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M288 0H32C14.328 0 0 14.328 0 32v160h320V32c0-17.672-14.328-32-32-32zm0 0",
    fill: "#39b54a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M352 48H0V32C0 14.328 14.328 0 32 0h288c17.672 0 32 14.328 32 32zm0 0",
    fill: "#004e29"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M288 0H32C14.328 0 0 14.328 0 32v16h320V32c0-17.672-14.328-32-32-32zm0 0",
    fill: "#006837"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M224 304h256v176H224zm0 0",
    fill: "#1f80aa"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M224 304h224v176H224zm0 0",
    fill: "#29abe2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M256 336h112v112H256zm0 0",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M256 336h88v112h-88zm0 0",
    fill: "#e6e6e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M336 448h-48v-24c0-13.258 10.742-24 24-24s24 10.742 24 24zm0 0",
    fill: "#603813"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M300 403.328c-7.145 4.16-12 11.809-12 20.672v24h24v-24c0-8.863-4.855-16.512-12-20.672zm0 0",
    fill: "#754c24"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M328 384c0 8.836-7.164 16-16 16s-16-7.164-16-16 7.164-16 16-16 16 7.164 16 16zm0 0",
    fill: "#8c6239"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ccc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176 160h-24v-16h24c4.414 0 8-3.594 8-8s-3.586-8-8-8c-13.23 0-24-10.77-24-24s10.77-24 24-24h24v16h-24c-4.414 0-8 3.594-8 8s3.586 8 8 8c13.23 0 24 10.77 24 24s-10.77 24-24 24zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 64h16v24h-16zm0 0M168 152h16v24h-16zm0 0M40 72h80v16H40zm0 0M40 104h80v16H40zm0 0M40 136h80v16H40zm0 0M232 72h80v16h-80zm0 0M232 104h80v16h-80zm0 0M232 136h80v16h-80zm0 0M40 216h32v16H40zm0 0M88 216h32v16H88zm0 0M136 216h32v16h-32zm0 0M184 216h32v16h-32zm0 0M232 216h32v16h-32zm0 0M280 216h32v16h-32zm0 0M40 296h32v16H40zm0 0M88 296h32v16H88zm0 0M136 296h32v16h-32zm0 0"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M392 336h64v16h-64zm0 0M392 368h64v16h-64zm0 0M392 400h64v16h-64zm0 0M392 432h64v16h-64zm0 0",
    fill: "#a67c52"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 184h352v16H0zm0 0",
    fill: "#004e29"
  })));
}

export default __webpack_public_path__ + "6cda817c0fd365100d2570e2ccd143e6.svg";
export { SvgCashBanksMovements as ReactComponent };